<div
  class="input-container-wrapper"
  [class.input-container-wrapper--with-label]="!!label()"
  >
  @if (suffix()) {
    <span class="suffix">{{ suffix() }}</span>
  }
  <ng-content></ng-content>
  @if (label()) {
    <label [attr.for]="contentId()">{{ label() }}</label>
  }
  @if (errorMessage()) {
    <span
      class="error-label"
      data-cy="input-container-error"
      >
      {{ errorMessage() }}
    </span>
  }
</div>
